export default {
  bind(el, binding, vnode) {
    let wrapperDown = false
    let wrapperUp = false
    if (!binding.value) return
    const handleMousedown = (event) => {
      try {
        wrapperDown = event.target.classList.contains('el-drawer__container')
      } catch (error) {
        console.log(error)
      }
    };
    el.addEventListener('mousedown', handleMousedown);
    el._drawerWrapperMousedownHandler = handleMousedown;

    const handleMouseup = (event) => {
      try {
        wrapperUp = event.target.classList.contains('el-drawer__container')
        if (wrapperDown && wrapperUp) {
          binding.value()
        }
      } catch (error) {
        console.log(error)
      }
    };
    el.addEventListener('mouseup', handleMouseup);
    el._drawerWrapperMouseupHandler = handleMouseup
  },

  unbind(el) {
    el.removeEventListener('mousedown', el._drawerWrapperMousedownHandler); // 清理事件监听
    el.removeEventListener('mouseup', el._drawerWrapperMouseupHandler); // 清理事件监听
  },
};